import axios, { AxiosResponse } from 'axios';

import { API_ROOT } from 'containers/App/constants';
import api from 'utils/api';
import API from 'utils/request';

import { checkPayloadForFile } from '../utils';

export const getBDOSettingsAPI = async (
  params: Record<string, any> = {},
  headers: Record<string, string> = {}
): Promise<any> => {
  let url = `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/card_items`;

  if (params?.type === 'evoucher' || params?.type === 'paper') {
    url += '?type[]=evoucher&type[]=paper';
    delete params.type;
  }

  const res = await API({
    url: url,
    params: params,
    headers: headers
  });
  return res.data;
};

export const getBDOSettingAPI = (id: number, headers): Promise<AxiosResponse<any>> => {
  return api({
    url: `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/card_items/${id}`,
    headers: headers
  });
};

export const updateBdoSettingAPI = async (body, params, headers) => {
  body = await checkPayloadForFile(body);
  return axios
    .put(
      `${API_ROOT}/v4/dash/custom/bdo/transfer_requests/card_items/${params.id}`,
      { card_item: body },
      {
        headers
      }
    )
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error.response;
    });
};

export const deleteBdoSettingAPI = (id: number, headers): Promise<AxiosResponse<any>> => {
  return axios
    .delete(`${API_ROOT}/v4/dash/custom/bdo/transfer_requests/card_items/${id}`, { headers })
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error.response;
    });
};

export const createBdoSettingAPI = async (body, headers) => {
  body = await checkPayloadForFile(body);
  return axios
    .post(`${API_ROOT}/v4/dash/custom/bdo/transfer_requests/card_items`, body, {
      headers
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const changeCardItemOrderApi = async (updatedRows: { id: number; sort_order: number }[]) => {
  if (updatedRows.some(row => row.sort_order < 1)) {
    return Promise.reject('Ordering cannot be less than 1');
  }
  return await API.patch('/v4/dash/custom/bdo/transfer_requests/card_items/sort', {
    card_items: updatedRows
  });
};

export const changeCardOrderApi = async (updatedRows: { id: number; sort_order: number }[]) => {
  if (updatedRows.some(row => row.sort_order < 1)) {
    return Promise.reject('Ordering cannot be less than 1');
  }
  return await API.patch('/v4/dash/custom/bdo/transfer_requests/cards/sort', {
    cards: updatedRows
  });
};
